import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBREntryId = createSelector([selectQbrState], (state) => state.entryId)
